import { useRouter } from "next/router"
import React, { useEffect, useState } from "react"

import { internalLink } from "~/services/helper"
import { useStores } from "~/stores/StoreProvider"

import FlowMessage from "./_FlowMessage"

export const FlowMessageForPromptToEnterProfile: React.VFC = () => {
  const router = useRouter()
  const { inputProfileFlowStore } = useStores()
  const [showFlowMessage, setShowFlowMessage] = useState(false)
  const [href, setHref] = useState("/")

  useEffect(() => {
    const isMessagePage = Boolean(router.pathname.match("/next/messages"))
    const hasFlowSteps = inputProfileFlowStore.isExistRoutingInfo
    setShowFlowMessage(!isMessagePage && hasFlowSteps)
    setHref(internalLink(`/input-profile-flow?close_url=${window.location.href}`))
  }, [router])

  return (
    <>
      {showFlowMessage && (
        <FlowMessage
          href={href}
          message="内定に大きく影響するプロフィールを入力しよう！"
          className="gtm_profile-input-flow-link-under-header"
        />
      )}
    </>
  )
}
